import React, { useId, useRef, useState } from "react";
import { createPortal } from "react-dom";

const GAP = 6;

const placementStyle = (rect, placement) => {
  switch (placement) {
    case "bottom":
      return { top: rect.bottom + GAP, left: rect.left + rect.width / 2, transform: "translateX(-50%)" };
    case "left":
      return { top: rect.top + rect.height / 2, left: rect.left - GAP, transform: "translate(-100%, -50%)" };
    case "right":
      return { top: rect.top + rect.height / 2, left: rect.right + GAP, transform: "translateY(-50%)" };
    case "top":
    default:
      return { top: rect.top - GAP, left: rect.left + rect.width / 2, transform: "translate(-50%, -100%)" };
  }
};

const Tooltip = ({ title, children, placement = "top", className = "" }) => {
  const [open, setOpen] = useState(false);
  const [rect, setRect] = useState(null);
  const anchorRef = useRef(null);
  const id = useId();

  if (!title) return children;

  const show = () => {
    if (anchorRef.current) setRect(anchorRef.current.getBoundingClientRect());
    setOpen(true);
  };
  const hide = () => setOpen(false);

  return (
    <span
      ref={anchorRef}
      className="relative inline-flex"
      onMouseEnter={show}
      onMouseLeave={hide}
      onFocus={show}
      onBlur={hide}
      aria-describedby={open ? id : undefined}
    >
      {children}
      {open && rect && createPortal(
        <span
          id={id}
          role="tooltip"
          style={placementStyle(rect, placement)}
          className={`pointer-events-none fixed z-[9999] whitespace-nowrap rounded-md bg-slate-900 px-2 py-1 text-xs text-white shadow-md ${className}`}
        >
          {title}
        </span>,
        document.body
      )}
    </span>
  );
};

export default Tooltip;
